export default {
    state:{
        in:false,
        user:{},
        videoshow : false
    },
    mutations:{
        login(state,payload){
            state.in=true
            state.user = payload
        },
        logout(state){
            state.in=false
            state.user = {}
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/login.js